export const EMAIL_SERVICE = `https://notify.everis.id/send/`;

export const RECIPIENT_EMAIL = `did@everis.com`;
